var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline-wrapper"},[_c('Timeline',{attrs:{"timeline-items":_vm.items,"message-when-no-items":_vm.messageWithNoItems,"order":"desc","unique-timeline":"true","color-dots":"#FF9FC3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }